import { Injectable } from '@angular/core'
import Cookies from 'js-cookie'

// The default expiry of the cookie not the authentication token.
// This needs to be slightly longer than the token duration so it
// token remains stored while it's valid.
// This can be overridden in <code>set</code> method.
const DEFAULT_EXPIRY_IN_DAYS = 7

@Injectable({
  providedIn: 'root',
})
export class CookieStorageService {
  getGlobal<T>(storageKey: string): T | undefined {
    const result = Cookies.get(storageKey)
    if (result === 'undefined' || result === 'null') {
      return undefined
    }
    return result as T
  }

  setGlobal(storageKey: string, data: any, expiryInDays?: number): void {
    const cookieAttributes: Cookies.CookieAttributes = {
      expires: expiryInDays ?? DEFAULT_EXPIRY_IN_DAYS,
      secure: true,
      sameSite: 'Lax',
    }
    if (data !== undefined && data !== null) {
      Cookies.set(storageKey, data, cookieAttributes)
    } else {
      Cookies.remove(storageKey)
    }
  }

  removeGlobal(storageKey: string): void {
    Cookies.remove(storageKey)
  }
}
